import { useTranslation } from 'react-i18next';

import { Card } from '../../../shared/ui/Card';
import { PageHeader } from '../../../shared/ui/PageHeader';
import { Spinner } from '../../../shared/ui/Spinner';
import { useDashboardMetrics } from '../hooks/useDashboardMetrics';
import styles from './DashboardPage.module.css';

// PARA-106, AC-7: агрегированные метрики использования.
export function DashboardPage(): JSX.Element {
  const { t } = useTranslation();
  const { data, isLoading } = useDashboardMetrics();

  const metrics = data
    ? [
        { label: t('dashboard.totalUsers'), value: data.total_users },
        { label: t('dashboard.totalTasks'), value: data.total_tasks },
        { label: t('dashboard.completedLast7Days'), value: data.completed_last_7_days },
      ]
    : [];

  return (
    <section>
      <PageHeader title={t('dashboard.title')} />
      {isLoading || !data ? (
        <Spinner />
      ) : (
        <div className={styles.grid}>
          {metrics.map((metric) => (
            <Card key={metric.label} className={styles.metric}>
              <span className={styles.value}>{metric.value}</span>
              <span className={styles.label}>{metric.label}</span>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
